'use strict';
const p = (r) => r.replaceAll("'", "").replaceAll(" ", "-").replaceAll("?", "").toLowerCase(), a = (r) => r.replace(r[0], r.charAt(0).toUpperCase()), c = (r, t = !1) => {
  let e = r;
  return t && (e = a(r)), e.replaceAll("-", " ");
}, l = (r) => r.replace(/\s+/g, "-").toLowerCase(), m = (r) => r.replace(/(<([^>]+)>)/gi, "").replace(/\r?\n|\r/g, ""), h = (r) => r <= 30 ? "1 month" : r <= 60 ? "2 months" : r <= 90 ? "3 months" : r <= 180 ? "6 months" : r <= 270 ? "9 months" : "12 months", u = (r) => r < 30 ? 1 : r < 60 ? 2 : r < 90 ? 3 : r < 180 ? 6 : r < 270 ? 9 : 12, f = (r, t) => `<?xml version="1.0" encoding="UTF-8"?>
   <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
     ${t.map(({ path: e, lastModifiedDate: o, changeFrequency: n, priority: s }) => `
       <url>
           <loc>${r}${e}</loc>
           <lastmod>${o}</lastmod>
           <changefreq>${n}</changefreq>
           <priority>${s}</priority>
       </url>
     `).join("")}
   </urlset>
 `;
export {
  u as billingFrequencyInDaysToMonthInteger,
  h as billingFrequencyInDaysToMonths,
  a as capitalise,
  l as formatKebab,
  f as generateSiteMapXML,
  m as htmlToString,
  p as hyphenate,
  c as removeHyphen
};
